import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;

  handleSearch: (e: string) => void;

  handleApply: () => void;

  handleUpdateActive: (e: { value: string | number; label: string }[]) => void;

  selectedActive: {
    value: string | number;
    label: string;
  }[];
}

const PresetsFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,

  handleApply,

  handleUpdateActive,
  selectedActive,
}) => {
  const { t } = useTranslation();

  const handleApplyActive = (
    e: { value: string | number; label: string }[],
  ) => {
    handleUpdateActive(e);
  };

  const handleClearFilters = () => {
    handleApplyActive([
      {
        value: 3,
        label: "All",
      },
    ]);

    handleSearch("");

    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      className="presets-filter"
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
        },
        {
          type: FilterItemTypes.radio,

          title: t("isActive"),

          boxTitle: t("isActive"),

          icon: gridIcon,

          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],

          activeItems: selectedActive,

          handleApply: handleApplyActive,
        },
      ]}
    />
  );
};

export default PresetsFilter;
